import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const OverduechargesAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		frequency: yup.string().required().label($t('frequency')),
		charge_type: yup.string().required().label($t('chargeType')),
		charges_amount: yup.number().required().label($t('chargesAmount')),
		charges_percent: yup.number().required().label($t('chargesPercent')),
		weaver_days: yup.number().required().label($t('weaverDays'))
	});
	
	//form default values
	const formDefaultValues = {
		frequency: '', 
		charge_type: '', 
		charges_amount: '', 
		charges_percent: '', 
		weaver_days: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/overduecharges`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="OverduechargesAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewOverduecharge')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('frequency')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="frequency"     optionLabel="label" optionValue="value" value={formik.values.frequency} onChange={formik.handleChange} options={app.menus.frequency2} label={$t('frequency')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.frequency)}   />
                                                <ErrorMessage name="frequency" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('chargeType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="charge_type"     optionLabel="label" optionValue="value" value={formik.values.charge_type} onChange={formik.handleChange} options={app.menus.chargeType} label={$t('chargeType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.charge_type)}   />
                                                <ErrorMessage name="charge_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('chargesAmount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="charges_amount"  onChange={formik.handleChange}  value={formik.values.charges_amount}   label={$t('chargesAmount')} type="number" placeholder={$t('enterChargesAmount')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.charges_amount)} />
                                                <ErrorMessage name="charges_amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('chargesPercent')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="charges_percent"  onChange={formik.handleChange}  value={formik.values.charges_percent}   label={$t('chargesPercent')} type="number" placeholder={$t('enterChargesPercent')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.charges_percent)} />
                                                <ErrorMessage name="charges_percent" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('weaverDays')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="weaver_days"  onChange={formik.handleChange}  value={formik.values.weaver_days}   label={$t('weaverDays')} type="number" placeholder={$t('enterWeaverDays')}  min={0}  step="any"    className={inputClassName(formik?.errors?.weaver_days)} />
                                                <ErrorMessage name="weaver_days" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
OverduechargesAddPage.defaultProps = {
	primaryKey: 'overdueid',
	pageName: 'overduecharges',
	apiPath: 'overduecharges/add',
	routeName: 'overduechargesadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default OverduechargesAddPage;
